/**
 * Created by BFR on 21/02/2016.
 */
define('sampleDetailView',[
  'module',
  'sampleCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!sampleDetailTabTpl',
  'dateUtils'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  dateConverter
) {
  'use strict';

  var SampleDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    onShow: function() {
      $.material.init();
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      templateData.ordDtString = dateConverter.toDateFormatString(this.model.get('ordDt'));
      templateData.receptDtString = dateConverter.toDateFormatString(this.model.get('receptDt'));
      templateData.sampleDtString = dateConverter.toDateFormatString(this.model.get('sampleDt'));
      templateData.datehhString = dateConverter.toDateFormatString(this.model.get('datehh')) + ' ' +
          dateConverter.toTimeFormatString(this.model.get('datehh'));
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        sampleModel: this.model
      });
      createEditView.show({
        title: _.i18n('samples.edit')
      });
    }

  });

  module.exports = SampleDetailView;
});
